export default {
  // 사이드 네비게이션
  navigation: {
    home: '홈',
    gameCenter: '게임 센터',
    rechargeCenter: '충전 센터',
    imChat: 'IM 채팅',
    consult: '컨설팅',
    starcast: '그룹 엔터테인먼트 라이브 스트리밍 플랫폼'
  },

  // 홈
  home: {
    platformFeatures: '플랫폼 특징',
    quickActionsName: '빠른 작업',
    footerText: '스트리밍을 더 간단하게, 상호작용을 더 재미있게',
    features: {
      gameCenter: {
        title: '게임 센터',
        description: '다양한 플랫폼 스트리밍을 지원하는 풍부한 게임 리소스',
      },
      imChat: {
        title: '인스턴트 메시징',
        description: '실시간 채팅 상호작용으로 시청자 경험 향상',
      },
      dataAnalysis: {
        title: '데이터 분석',
        description: '스트리밍 성능 최적화를 위한 상세한 통계',
      },
      efficientStable: {
        title: '효율적이고 안정적',
        description: '안정적인 서비스로 매끄러운 스트리밍 경험',
      },
    },
    stats: {
      activeUsers: '활성 사용자',
      gameResources: '게임 리소스',
      serviceAvailability: '서비스 가용성',
      technicalSupport: '기술 지원',
    },
    quickActions: {
      gameCenter: '게임 센터',
      imChat: 'IM 채팅',
      consult: '컨설팅',
    },
  },

  // 게임 센터
  gameCenter: {
    language: '한국어',
    balance: '잔액',
    hotGames: '인기 게임',
    download: '다운로드',
    update: '업데이트',
    startTikTok: '틱톡 시작',
    startBigo: '비고 시작',
    document: '문서',
    currentGame: '현재 라이브 게임: ',
    currentStatus: '현재 라이브 상태: ',
    recharge: '충전',
    restart: '도구 및 게임 재시작',
    closeLive: '라이브 종료',
    downloadProgress: '다운로드 진행률: ',
    decompProgress: '압축 해제 진행률: ',
    waitDecomp: '압축 해제 대기 중',
    fixBug: '버그 수정',
    clickUpdate: '업데이트 클릭',
    downloading: '다운로드 중, 잠시만 기다려 주세요~',
    pay: '결제 중...',
    xzf: '결제 필요',
    zs: '다이아몬드',
    dest: '단무 게임 안티 블로킹 플러그인',
    getff: '플러그인 해제',
    ffbtun: '반(反)기계 리뷰 방송',
    qrkb: '라이브 스트리밍 확인',
    tkl: '안티머신 리뷰와 방송을 시작할 준비가 되셨나요?',
    qd: '확인',
    qx: '취소',
  },

  // IM 채팅
  imChat: {
    search: '검색',
    searchNoResult: '해당 사용자를 찾을 수 없습니다',
    tryOtherKeywords: '다른 검색어를 시도해 보세요',
    noConversations: '채팅 기록이 없습니다',
    startChatting: '사용자를 검색해서 채팅을 시작하세요',
    loadingConversations: '대화 목록 로딩 중...',
    connecting: '채팅 서버에 연결 중...',
    connectionFailed: '⚠️연결 실패, 채팅 기능 사용 불가',
    checkNetwork: '네트워크 연결을 확인하거나 고객센터에 문의하세요',
    selectUser: '채팅을 시작할 사용자를 선택하세요',
    sending: '전송 중...',
    sendMessage: '전송',
    enterMessage: '메시지를 입력하세요...',
    noMessages: '메시지가 없습니다',
    officialUser: '성우 인터랙티브',
    welcomeChat: '채팅 기능을 이용해 주셔서 감사합니다',
    selectConversationHint: '왼쪽에서 대화를 선택하여 채팅을 시작하세요',
    inputDisabledDisconnected:
      '연결이 끊어졌습니다. 채팅을 일시적으로 사용할 수 없습니다. 다른 기능은 정상입니다. 채팅 기능을 복구하려면 다시 로그인하세요.',
    inputDisabledOfficialNotification: '공식 알림은 단방향 알림이므로 메시지만 받을 수 있습니다',
    RecentSessions: '최근 대화',
    RecommendedChat: '글로벌 프렌즈',
    Online: '온라인',
    Offline: '오프라인',
  },

  // 咨询
  StalConsult: {
    search2: '검색',
    all: '전체',
    Payment: '결제',
    ViewFullContent: '전체 콘텐츠 보기',
    UnlockFullContent: '전체 콘텐츠 잠금 해제',
    NeedToPay: '결제 필요',
    diamond: '다이아몬드',
    CurrentBalance: '현재 잔액',
    Cancel: '취소',
    PayNow: '지금 결제',
    InsufficientBalance: '잔액 부족',
    loading: '로딩 중...',
    NoMoreContent: '더 이상 콘텐츠가 없습니다',
    return: '반품',
    fd: '확대해서 보세요',
  },

  // 공통
  common: {
    confirm: '확인',
    cancel: '취소',
    save: '저장',
    delete: '삭제',
    edit: '편집',
    loading: '로딩 중...',
    success: '성공',
    failed: '실패',
    error: '오류',
    warning: '경고',
    info: '정보',
  },
}
